<div class="user-card"
     [class.portal-clickable]="this.node?.group"
     (click)="toggleExpand()">
  <al-user-card [resource]="resource"
                [department]="row?.department"
                [classification]="row?.classification"
                [isUnassignedUser]="isUnassignedUser" />
</div>

<al-cell-drop-zone [node]="node"
                   [droppable]="isDroppable"
                   (dragOverDelay)="expand()" />